// lodash
import isString from 'lodash/isString';

export default function getClickAndCollectStoreIdFromPath({ path = '', prefix = 'store-details' }) {

  if (isString(path) && isString(prefix)) {
    const arr = path.split('/');

    if (arr.indexOf(prefix) !== -1) {
      const prefixIndex = arr.indexOf(prefix);
      return arr[prefixIndex + 1] || '';
    }
  }
  return '';
}
